import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './app';
import './css/globals.css';
import reportWebVitals from './reportWebVitals';
import AppProviders from './shared/components/app-providers';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
